import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class TrainingMFActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsTrainingMF' {
    return 'actionPointsTrainingMF';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.TRAINING_MF;
  }
}
